export const QA_ATTRIBUTE = 'data-qa-tag';

const APP_PREFIX = 'support-app-';

// nai items
export const SUPPORT_NAV_ITEM_GUIDES = `${APP_PREFIX}-nav-item-guides`;
export const SUPPORT_NAV_ITEM_FAQ = `${APP_PREFIX}-nav-item-faq`;
export const SUPPORT_NAV_ITEM_RELEASE_NOTES = `${APP_PREFIX}-nav-item-release-notes`;
export const SUPPORT_NAV_ITEM_SUPPORT_HISTORY = `${APP_PREFIX}-nav-item-support-history`;
export const SUPPORT_NAV_ITEM_LOG_OUT = `${APP_PREFIX}-nav-item-log-out`;
export const SUPPORT_SIDEBAR_CONTACT_US = `${APP_PREFIX}-sidebar-contact-us`;

// contact us
export const SUPPORT_CONTACT_US_BUTTON = `${APP_PREFIX}-contact-us-button`;
export const SUPPORT_CONTACT_US_MODAL = `${APP_PREFIX}-contact-us-modal`;
export const SUPPORT_CONTACT_US_MODAL_EMAIL = `${APP_PREFIX}-contact-us-modal-email`;
export const SUPPORT_CONTACT_US_MODAL_SUBJECT = `${APP_PREFIX}-contact-us-modal-subject`;
export const SUPPORT_CONTACT_US_MODAL_MESSAGE = `${APP_PREFIX}-contact-us-modal-message`;
export const SUPPORT_CONTACT_US_MODAL_SUBMIT = `${APP_PREFIX}-contact-us-modal-submit`;
export const SUPPORT_CONTACT_US_MODAL_CANCEL = `${APP_PREFIX}-contact-us-modal-cancel`;
export const SUPPORT_CONTACT_US_MODAL_TOPIC = `${APP_PREFIX}-contact-us-modal-topic`;
export const SUPPORT_CONTACT_US_MODAL_ADD_ATTACHMENT = `${APP_PREFIX}-contact-us-modal-add-attachment`;

//thank you modal
export const SUPPORT_THANK_YOU_MODAL = `${APP_PREFIX}-thank-you-modal`;
export const SUPPORT_THANK_YOU_MODAL_CLOSE = `${APP_PREFIX}-thank-you-modal-close`;
export const SUPPORT_THANK_YOU_MODAL_TICKET_LINK = `${APP_PREFIX}-thank-you-modal-ticket-link`;
export const SUPPORT_THANK_YOU_MODAL_TICKETS_LIST_LINK = `${APP_PREFIX}-thank-you-modal-tickets-list-link`;

// header
export const SUPPORT_HEADER_SEARCH = `${APP_PREFIX}-header-search`;
export const SUPPORT_HEADER_SEARCH_INPUT = `${APP_PREFIX}-header-search-input`;
export const SUPPORT_HEADER_SEARCH_RESULT = `${APP_PREFIX}-header-search-result`;
export const SUPPORT_HEADER_SEARCH_CLEAR = `${APP_PREFIX}-header-search-clear`;
export const SUPPORT_HEADER_LOGIN = `${APP_PREFIX}-header-login`;
export const SUPPORT_HEADER_STATUS = `${APP_PREFIX}-header-status`;
export const SUPPORT_SEATCH_SHOW_MORE = `${APP_PREFIX}-search-show-more`;

// help-center
// guides page
export const SUPPORT_HELP_CENTER_CATEGORY_CARD = `${APP_PREFIX}-help-center-category-card`;

// categpry page
export const SUPPORT_HELP_CENTER_SUB_CATEGORY_NAME = `${APP_PREFIX}-help-center-sub-category-name`;
export const SUPPORT_HELP_CENTER_ARTICLE_LINK = `${APP_PREFIX}-help-center-article-link`;

// topic page
export const SUPPORT_HELP_CENTER_TOPIC_NAME = `${APP_PREFIX}-help-center-topic-name`;
export const SUPPORT_HELP_CENTER_TOPIC_TEXT = `${APP_PREFIX}-help-center-topic-text`;
export const SUPPORT_HELP_CENTER_CATEGORY_NAME = `${APP_PREFIX}-help-center-category-name`;
export const SUPPORT_HELP_CENTER_CATEGORY_DESCRIPTION = `${APP_PREFIX}-help-center-category-description`;
export const SUPPORT_HELP_CENTER_TOPIC_RELATED_LIST = `${APP_PREFIX}-help-center-topic-related-list`;

export const SUPPORT_RAING_BUTTON = `${APP_PREFIX}-rating-button`;

// breadcrumbs
export const BREADCRUMBS_CATEGORY = `${APP_PREFIX}-breadcrumbs-category`;
export const BREADCRUMBS_TOPIC = `${APP_PREFIX}-breadcrumbs-topic`;
export const BREADCRUMBS_FAQ = `${APP_PREFIX}-breadcrumbs-faq`;
export const BREADCRUMBS_TICKET = `${APP_PREFIX}-breadcrumbs-ticket`;
export const BREADCRUMBS_CHAT = `${APP_PREFIX}-breadcrumbs-chat`;

// faq
export const SUPPORT_HELP_CENTER_FAQ_CARD = `${APP_PREFIX}-support-help-center-faq-card`;
export const SUPPORT_HELP_CENTER_FAQ_NAME = `${APP_PREFIX}-support-help-center-faq-name`;
export const SUPPORT_HELP_CENTER_FAQ_TOPIC = `${APP_PREFIX}-support-help-center-faq-topic`;

// release notes
export const SUPPORT_HELP_CENTER_RELEASE_NOTE = `${APP_PREFIX}-help-center-release-note`;
export const SUPPORT_HELP_CENTER_RELEASE_NOTE_TEXT = `${APP_PREFIX}-help-center-release-note-text`;

// support history

export const SUPPORT_HISTORY_PAGE_TITLE = `${APP_PREFIX}-history-title`;
export const SUPPORT_HISTORY_FILTER = `${APP_PREFIX}-history-filter`;
export const SUPPORT_HISTORY_TABS = `${APP_PREFIX}-history-tabs`;
export const SUPPORT_HISTORY_CONTENT_TICKET = `${APP_PREFIX}-history-content-ticket`;
export const SUPPORT_HISTORY_CONTENT_CHAT = `${APP_PREFIX}-history-content-chat`;
export const SUPPORT_HISTORY_TICKET_ITEM = `${APP_PREFIX}-history-ticket-item`;
export const SUPPORT_HISTORY_CHAT_ITEM = `${APP_PREFIX}-history-chat-item`;

// support search
export const SUPPORT_SEARCH_RESULTS = `${APP_PREFIX}-search-results`;
export const SUPPORT_SEARCH_RESULT_ITEM = `${APP_PREFIX}-search-result-item`;
export const SUPPORT_SEARCH_RESULT_ITEM_TITLE = `${APP_PREFIX}-search-result-item-title`;
export const SUPPORT_SEARCH_RESULT_ITEM_DESCRIPTION = `${APP_PREFIX}-search-result-item-text`;
export const SUPPORT_SEARCH_RESULT_ITEM_TYPE_SELECTION = `${APP_PREFIX}-search-result-item-type-selection`;

// ticket
export const SUPPORT_TICKET_STATUS = `${APP_PREFIX}-ticket-status`;
export const TICKET_MESSAGE = `${APP_PREFIX}-ticket-message`;
export const SUPPORT_TICKET_OPEN_ON_REPLY = `${APP_PREFIX}-ticket-open-on-reply`;
export const SUPPORT_TICKET_RESOLVE = `${APP_PREFIX}-ticket-resolve`;
export const SUPPORT_TICKET_ATTACHMENT = `${APP_PREFIX}-ticket-attachment`;
export const SUPPORT_TICKET_REPLY = `${APP_PREFIX}-ticket-reply`;
export const SUPPORT_TICKET_TEXTAREA = `${APP_PREFIX}-ticket-textarea`;

// chat
export const SUPPORT_CHAT_MESSAGE = `${APP_PREFIX}-chat-message`;
export const SUPPORT_CHAT_ATTACHMENT = `${APP_PREFIX}-chat-attachment`;
export const SUPPORT_CHAT_RATE = `${APP_PREFIX}-chat-rate`;

export const SUPPORT_COLLAPSE_BUTTON_OPEN = `${APP_PREFIX}-collapse-button-open`;
export const SUPPORT_COLLAPSE_BUTTON_CLOSE = `${APP_PREFIX}-collapse-button-close`;
export const SUPPORT_CARD_NAME = `${APP_PREFIX}-card-name`;
export const SUPPORT_CARD_ICON = `${APP_PREFIX}-card-icon`;
export const SUPPORT_PAGE_TITLE = `${APP_PREFIX}-page-title`;

export const LOG_IN_BUTTON = `${APP_PREFIX}-log-in-button`;
